module.exports = __webpack_public_path__ + "img/acrp-logo.3f560a26.jpg";